/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// set initial product data -- product all variants
var grab_data__price = $(".Product--All-Variants .Savings--Item input:checked").parent().find("#per_gram").text();
var grab_data__savings = $(".Product--All-Variants .Savings--Item input:checked").parent().find("#per_gram--save").text();
$(".Product--All-Variants #price_per_gram").text(grab_data__price);
$(".Product--All-Variants #price_per_gram--save").text(grab_data__savings);

$(document).ready(function(){
  
  //click-active function
  function click_event(ct,t){
    $("body").on("click", ct, function(){
      $(t).toggleClass("active");
    })
  }
  
  // hack to allow search drop to be triggered within sidebar
  let sidebar_search = $("#sidebar_search");
  
  $(sidebar_search).click(function(e){
    e.preventDefault();
    $('[data-action = "close-drawer"]')[0].click();
    $('[data-action = "toggle-search"]')[0].click();
  });
  
  // cart page
  click_event("#Cart__NoteCarret__id",".Cart__NoteContainer");
  click_event("#Cart_Estimates--trigger",".ShippingEstimates--Section");
  
  // product all-variant reviews
  $("#ar--text").click(function(){
  	$(".all-variants--review-section").toggleClass("active");
    if($(this).text() === "SEE REVIEWS"){
      $(this).text("HIDE REVIEWS");
      $(this).parent().find("svg").css("transform","rotate(180deg)");
    }else{
      $(this).text("SEE REVIEWS");
      $(this).parent().find("svg").css("transform","none");
    }
  });

  // product single variants - mobile
  if($(window).width() < 641){
    $(".ProductMeta__Description--mobile-title").click(function(){
      $(this).toggleClass("active");
      $(this).parent().find(".Rte").toggleClass("active");
    });
  }

  // location elements  
  var featured_homepage = $(".lc_based_section .TabList__Item");
  var header_item = $("#section-header .HorizontalList__Item a");
  var sidebar_item = $("#sidebar-menu .SidebarMenu__Nav .Collapsible__Button");
  var slideshow_button = $(".Slideshow .lc_based_button");
  var footer_button = $("footer .lc_based_button");
  var cart_button = $(".Cart--Section .EmptyState__Action");
  var featured_mobile_rest = $(".index-featured--all-rest");
  var featured_mobile_vietnam = $(".index-featured--all-vietnam");
  var featured_mobile_india = $(".index-featured--all-india");
  

  // product links
  const all_variants_rest = `/products/mazaeus-persian-saffron-all-variants`;
  const all_variants_india = `/products/mazaeus-persian-saffron-all-variants-i`;
  const all_variants_vietnam = `/products/mazaeus-persian-saffron-all-variants-v`;
  
  // getting the location
  $.get("https://www.cloudflare.com/cdn-cgi/trace", function(data) {
    
	/* ## VIETNAM ## */
    
    if(data.toLowerCase().indexOf("loc=vn") > -1 ) {
      console.log("lc:vn");

      // redirect if on the wrong product page
      
      if (window.location.href.indexOf("all-variants") > -1) {
        if (window.location.href.indexOf(all_variants_vietnam) == -1) {
          window.location.href = all_variants_vietnam;
        }
      }
      
      // main menu

      $(header_item[0]).attr("href", all_variants_vietnam);
      $(sidebar_item[0]).attr("href", all_variants_vietnam);

      // buttons

      $(slideshow_button[0]).attr("href", all_variants_vietnam);
      $(footer_button[0]).attr("href", all_variants_vietnam);
      
      if($(cart_button[0]).length){
        $(cart_button[0]).attr("href", all_variants_vietnam);
      }

      // featured collections 
      $(featured_homepage[0]).removeClass("is-active");
      $(featured_homepage[0]).css("display","none");
      $(featured_homepage[1]).click();
      $(featured_homepage[1]).addClass("is-active");
      $(featured_homepage[2]).css("display","none");
      
      $(featured_mobile_rest[0]).css("display","none");
      $(featured_mobile_vietnam[0]).css("display","none");

    /* ## IDNIA ## */
      
    }else if(data.toLowerCase().indexOf("loc=in") > -1 ) {
      
      console.log("lc:in");
      
      // redirect if on the wrong product page
      
      if (window.location.href.indexOf("all-variants") > -1) {
        if (window.location.href.indexOf(all_variants_india) == -1) {
          window.location.href = all_variants_india;
        }
      }

      // main menu

      $(header_item[0]).attr("href", all_variants_india);
      $(sidebar_item[0]).attr("href", all_variants_india);

      // buttons

      $(slideshow_button[0]).attr("href", all_variants_india);
      $(footer_button[0]).attr("href", all_variants_india);
      
      if($(cart_button[0]).length){
        $(cart_button[0]).attr("href", all_variants_india);
      }
      
      // featured collections
      $(featured_homepage[0]).removeClass("is-active");
      $(featured_homepage[0]).css("display","none");
      $(featured_homepage[1]).css("display","none");
      $(featured_homepage[2]).click();
      $(featured_homepage[2]).addClass("is-active");

      $(featured_mobile_rest[0]).css("display","none");
      $(featured_mobile_vietnam[0]).css("display","none");
      
      /* ## WORLD ## */
      
    }else {
      console.log("lc:wrld");
      
      // redirect if on the wrong product page
      
      if (window.location.href.indexOf("all-variants") > -1) {
        if (window.location.href.indexOf("all-variants-i") > -1 || window.location.href.indexOf("all-variants-v") > -1 ) {
          window.location.href = all_variants_rest;
        }
      }
      
      // featured collections
      $(featured_homepage[1]).css("display","none");
      $(featured_homepage[2]).css("display","none");
      
      $(featured_mobile_india[0]).css("display","none");
      $(featured_mobile_vietnam[0]).css("display","none");
      
      if($(cart_button[0]).length){
        $(cart_button[0]).attr("href", all_variants_rest);
      }
    }
  });

});

